import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorPage from '@/app/pages/ErrorPage';
import { logger } from '@/shared/logger';
import { isChunkImportError } from './isChunkImportError';

/**
 * Error element for the data router. React Router v7 catches render/loader/action
 * errors and swaps in the nearest `errorElement` — a component boundary wrapping
 * <RouterProvider> never sees them. Wired at the root of the tree so it covers
 * root, auth and app alike, and reports every catch to Sentry via the logger.
 *
 * A stale chunk after a deploy (`preloadErrorGuard` already reloads for this) is
 * expected and self-healing, so it's reported at warning level instead of as a full
 * exception — otherwise it drowns out route errors that are genuine bugs.
 */
const RouteErrorBoundary = () => {
	const error = useRouteError();

	useEffect(() => {
		if (isChunkImportError(error)) {
			logger.warn('Route error boundary caught a stale chunk import failure', error);
			return;
		}

		logger.error('Route error boundary caught an error', error);
	}, [error]);

	return <ErrorPage />;
};

export default RouteErrorBoundary;
